module.exports = __webpack_public_path__ + "img/playultra.4c48e17c.png";